define('PackItem', [
    'Item.KeyMapping',
    'SC.Configuration',
    'underscore',
    'Utils'
], function PackItem(
    ItemKeyMapping,
    Configuration,
    _
) {
    'use strict';

    return {
        mountToApp: function mountToApp() {
            var itemKeyMapping = ItemKeyMapping.getKeyMapping(Configuration);

            /* eslint-disable dot-notation */
            Configuration.itemKeyMapping = _(Configuration.itemKeyMapping || {}).extend({
                _isfulfillable: function isFulfillable(item) {
                    var wrapperType = item.get('custitem_cps_wrapper_type');

                    return (wrapperType && wrapperType.toLowerCase() === 'pack') || itemKeyMapping['_isfulfillable'].apply(item, arguments);
                }
            });
            /* eslint-enable dot-notation */
        }
    };
});

